<template>
  <div class="form_main">
    <el-form :model="indiaIbtForm" :ref="formName" :rules="dasshpeRules">
      <ul class="clearfix">
        <li class="fl">
          <AccountNumber
            v-if="regulator == 'svg'"
            :supportedCurrenciesList="validCurrencies"
            @setCurrency="setCurrency"
            @setAccountNumber="setAccountNumber"
          ></AccountNumber>

          <AccountNumber
            v-else
            supportedCurrencies="USD"
            @setCurrency="setCurrency"
            @setAccountNumber="setAccountNumber"
          ></AccountNumber>
        </li>
        <li class="fr">
          <numeric-input
            v-model="indiaIbtForm.amount"
            :currency="accountCurrency"
            :precision="2"
            :label="$t('common.field.amt')"
            name="amount"
            @blur="onAmountBlur"
          ></numeric-input>
        </li>
      </ul>
      <ul class="clearfix">
        <li class="fl">
          <SelectForm
            v-model="indiaIbtForm.mopCode"
            name="mopCode"
            :label="$t('common.field.bankName')"
            data-testid="BankList"
          >
            <el-option
              v-for="(value, name) in bankList"
              :key="name"
              :value="name"
              :label="value"
              :data-testid="value"
            ></el-option>
          </SelectForm>
        </li>
        <li class="fr">
          <InputForm
            :label="$t('common.field.imptNotes')"
            name="applicationNotes"
            v-model="indiaIbtForm.notes"
          ></InputForm>
        </li>
      </ul>
      <ul class="clearfix">
        <li class="fl data">
          <p>
            {{
              $t('deposit.default.rate.rate', {
                oldCurrency: accountCurrency ? accountCurrency : 'USD',
                newCurrency: 'INR'
              })
            }}<span>{{ rate }}</span>
          </p>
          <p>
            INR: <span>{{ rateChange }}</span>
          </p>
        </li>
      </ul>
      <DepositDiscount
        v-if="isLoyalty"
        v-bind="depositDiscountProps"
        @setDepositDiscount="setDepositDiscount"
        :discRateChange="{ currency: 'INR', rate: this.rate, dp: 2, case: 4 }"
      />
      <div class="form_button">
        <el-button class="el-button blue_button" :loading="loading" @click="submitForm()" data-testid="submit">
          {{ $t('common.button.submit') }}
        </el-button>
      </div>
    </el-form>
    <div v-html="bankHTML"></div>
  </div>
</template>

<script>
import NumericInput from '@/components/NumericInput';
import AccountNumber from '@/components/form/AccountNumber';
import mixin from '@/mixins/page/deposit';
import indiaIbtDasshpe from '@/mixins/page/deposit/indiaIbtDasshpe';
import { apiDasshpeNB_banklist, apiDasshpeNB_payment } from '@/resource';

export default {
  name: 'Dasshpe',
  components: { NumericInput, AccountNumber },
  mixins: [mixin, indiaIbtDasshpe],
  data() {
    return {
      minLimit: 30,
      validCurrencies: ['USD', 'USC'],
      formName: 'indiaIbtForm'
    };
  },
  methods: {
    getBankList() {
      apiDasshpeNB_banklist()
        .then(resp => {
          if (resp.data.code == 0) {
            this.bankList = resp.data.data;
          }
        })
        .catch(err => {
          this.loading = false;
          this.errorMessage(this.$t('deposit.default.failed'));
        });
    },
    submitDeposit() {
      return apiDasshpeNB_payment(
        {
          mt4Account: this.indiaIbtForm.accountNumber,
          operateAmount: this.indiaIbtForm.amount,
          mopCode: this.indiaIbtForm.mopCode,
          depositAmount: this.rateChange,
          rate: this.USDrate,
          applicationNotes: this.indiaIbtForm.notes,
          redemptionCode: this.voucherID
        },
        this.token
      );
    }
  },
  mounted() {
    this.getBankList();
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/deposit/default.scss';
</style>
